export default __webpack_public_path__ + "static/media/dino_ANGRY.f374d105.png";